module.exports = __webpack_public_path__ + "static/media/risk_icon_custom.845df35f.svg";